import { initAjaxFormSubmission } from "./form-ajax";
import { markCtaPopupForms } from "./form-cta-success";
export {
  applyCtaSuccessMessage,
  extractConfirmationFromHtml,
  finishCtaPopupSuccess,
  getDefaultCtaSuccessMessage,
  hasBackendCtaSuccessMessage,
  isCtaPopupSuccessState,
  markCtaPopupForms,
  resolveCtaPopupContext,
  showCtaFormSuccess,
} from "./form-cta-success";

// Form Validation
export const initForms = () => {
const mainForm = document.querySelectorAll('form:not([data-form-initialized])');

if (mainForm.length) {
  mainForm.forEach((form) => {
    form.dataset.formInitialized = '1';
  });
  mainForm.forEach((form) => {
    const formInputRequired = form.querySelectorAll('.form-control[required="required"]');
    const formMailRequired = form.querySelectorAll('.form-control[type="email"]');
    const formUrlRequired = form.querySelectorAll('.form-control[type="url"]');
    const formCheckRequired = form.querySelectorAll('.custom-control-input[required="required"]');
    const formButton = form.querySelector('.btn[type="submit"]');
    const fileInputs = form.querySelectorAll('.form-control[type="file"]');
    const formSelectRequired = form.querySelectorAll('select.form-control[required="required"]');

    if (formInputRequired.length) {
      formInputRequired.forEach((input) => {
        if (formButton) {
          formButton.addEventListener('click', () => {
            if (!input.value) {
              input.classList.add('error');
              const formGroup = input.closest('.form-group');
              if (formGroup) {
                formGroup.classList.add('form-group-error');
              }
            } else {
              input.classList.remove('error');
              input.closest('.form-group').classList.remove('form-group-error');
              input.classList.add('success');
              input.closest('.form-group').classList.add('form-group-success');
            }
          });
        }

        input.addEventListener('keyup', () => {
          if (input.value) {
            input.classList.remove('error');
            input.closest('.form-group').classList.remove('form-group-error');
            input.classList.add('success');
            input.closest('.form-group').classList.add('form-group-success');
          } else {
            input.classList.add('error');
            input.closest('.form-group').classList.add('form-group-error');
            input.classList.remove('success');
            input.closest('.form-group').classList.remove('form-group-success');
          }
        });
      });
    }

    if (formMailRequired) {
      formMailRequired.forEach((input) => {
        input.addEventListener('keyup', () => {
          const validRegex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
          if (input.value && input.value.match(validRegex)) {
            input.classList.remove('error');
            input.classList.add('success');
            input.closest('.form-group').classList.remove('form-group-error');
            input.closest('.form-group').classList.add('form-group-success');
          } else {
            input.classList.add('error');
            input.classList.remove('success');
            input.closest('.form-group').classList.add('form-group-error');
            input.closest('.form-group').classList.remove('form-group-success');
          }
        });
      });
    }


    if (formUrlRequired) {
      formUrlRequired.forEach((input) => {
        input.addEventListener('keyup', () => {
        const validUrlRegex = /^https?:\/\/([\w-]+\.)+[\w-]+(\/[\w-./?%&=]*)?$/;
        if (input.value && input.value.match(validUrlRegex)) {
          input.classList.remove('error');
          input.classList.add('success');
          input.closest('.form-group').classList.remove('form-group-error');
          input.closest('.form-group').classList.add('form-group-success');
        } else {
          input.classList.add('error');
          input.classList.remove('success');
            input.closest('.form-group').classList.add('form-group-error');
            input.closest('.form-group').classList.remove('form-group-success');
          }
        });
      });
    }

    if (formSelectRequired.length) {
      formSelectRequired.forEach((select) => {
        select.addEventListener('change', () => {
          const formGroup = select.closest('.form-group');
          if (select.value) {
            // ✅ Remove error and add success when value is selected
            select.classList.remove('error');
            select.classList.add('success');
            formGroup?.classList.remove('form-group-error');
            formGroup?.classList.add('form-group-success');
          } else {
            // ❌ Add error if still empty
            select.classList.add('error');
            select.classList.remove('success');
            formGroup?.classList.add('form-group-error');
            formGroup?.classList.remove('form-group-success');
          }
        });
      });
    }

    if (formCheckRequired) {
      formCheckRequired.forEach((check) => {
        if (formButton) {
          formButton.addEventListener('click', () => {
            if (check.checked === false) {
              if (document.querySelector('.form-navigation')) {
                document.querySelector('.form-navigation').classList.add('disabled');
              }
              check.classList.add('error');
              check.closest('.form-group').classList.add('form-group-error');
            }
          });
        }

        check.onchange = function () {
          if (check.checked === true) {
            check.classList.remove('error');
            check.classList.add('success');
            check.closest('.form-group').classList.remove('form-group-error');
            check.closest('.form-group').classList.add('form-group-success');
          } else {
            check.classList.add('error');
            check.classList.remove('success');
            check.closest('.form-group').classList.add('form-group-error');
            check.closest('.form-group').classList.remove('form-group-success');
          }
        };
      });
    }

    form.addEventListener(
      "submit",
      (event) => {
        form.classList.add("was-validated");
        if (!form.checkValidity()) {
          event.preventDefault();
          event.stopPropagation();
        }
      },
      false
    );
  });
}
};

export const initFormSelects = () => {
  const fromSelect = document.querySelector('[id$="singleselect-1"]');
  const toSelect = document.querySelector('[id$="singleselect-2"]');

  if (fromSelect && toSelect && fromSelect.dataset.formSelectInitialized !== "1") {
    fromSelect.dataset.formSelectInitialized = "1";
    fromSelect.addEventListener("change", function () {
      const selectedValue = this.value;

      Array.from(toSelect.options).forEach((option) => {
        option.disabled = false;
      });

      if (selectedValue) {
        const matchingToOption = Array.from(toSelect.options).find(
          (option) => option.value === selectedValue
        );
        if (matchingToOption) {
          matchingToOption.disabled = true;
        }

        const lastToOption = Array.from(toSelect.options)
          .filter((option) => option.value && !option.disabled)
          .at(-1);

        if (lastToOption) {
          toSelect.value = lastToOption.value;
        }
      }

      updateCustomSelectDisplay(toSelect);
    });
  }

  // Helper function to update custom select display
  function updateCustomSelectDisplay(select) {
    const customContainer = document.querySelector(`.custom-select-container .custom-select-header[data-target="${select.id}"]`)?.closest('.custom-select-container');
    if (!customContainer) return;

    // Update display text based on current selection
    const selectedSpan = customContainer.querySelector('.custom-select-selected');
    if (selectedSpan && select.value) {
      const selectedOption = select.options[select.selectedIndex];
      if (selectedOption) {
        selectedSpan.textContent = selectedOption.textContent.trim();
      }
    }

    // Update disabled states
    const options = customContainer.querySelector('.custom-select-options');
    options.querySelectorAll('.custom-select-option').forEach(option => {
      const value = option.dataset.value;
      const originalOption = Array.from(select.options).find((item) => item.value === value);
      const isDisabled = originalOption && originalOption.disabled;

      option.classList.toggle('disabled', isDisabled);
      option.classList.toggle('selected', select.value === value);
      option.style.opacity = isDisabled ? '0.5' : '1';
      option.style.cursor = isDisabled ? 'not-allowed' : 'pointer';
    });
  }

  let customSelectOutsideClickBound = false;

  // Custom Select Functionality
  function initCustomSelects() {
    if (!customSelectOutsideClickBound) {
      customSelectOutsideClickBound = true;
      document.addEventListener('click', function(e) {
        if (!e.target.closest('.custom-select-container')) {
          document.querySelectorAll('.custom-select-options').forEach(options => {
            options.style.display = 'none';
          });
          document.querySelectorAll('.custom-select-header').forEach(header => {
            header.classList.remove('active');
          });
          document.querySelectorAll('.custom-select-arrow').forEach(arrow => {
            arrow.classList.remove('active');
          });
        }
      });
    }

    document.querySelectorAll('.custom-select-container:not([data-custom-select-init])').forEach(container => {
      container.dataset.customSelectInit = '1';
      const header = container.querySelector('.custom-select-header');
      const options = container.querySelector('.custom-select-options');
      const selectedSpan = header.querySelector('.custom-select-selected');
      const arrow = header.querySelector('.custom-select-arrow');
      const targetId = header.dataset.target;
      const originalSelect = document.getElementById(targetId);

      // Set initial display
      if (originalSelect && originalSelect.value) {
        const selectedOption = originalSelect.options[originalSelect.selectedIndex];
        if (selectedOption) {
          selectedSpan.textContent = selectedOption.textContent;
        }
      }

      // Don't sync on load - let user choose

      // Handle header click
      header.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();

        // Close all other dropdowns
        document.querySelectorAll('.custom-select-options').forEach(otherOptions => {
          if (otherOptions !== options) {
            otherOptions.style.display = 'none';
            otherOptions.closest('.custom-select-container').querySelector('.custom-select-header').classList.remove('active');
            otherOptions.closest('.custom-select-container').querySelector('.custom-select-arrow').classList.remove('active');
          }
        });

        // Toggle current dropdown
        const isVisible = options.style.display === 'block';
        options.style.display = isVisible ? 'none' : 'block';
        header.classList.toggle('active', !isVisible);
        arrow.classList.toggle('active', !isVisible);
      });

      // Handle option clicks
      options.querySelectorAll('.custom-select-option').forEach(option => {
        option.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();

          const value = this.dataset.value;
          const text = this.textContent.trim();

          // Check if option is disabled in original select
          if (originalSelect) {
            const originalOption = originalSelect.querySelector(`option[value="${value}"]`);
            if (originalOption && originalOption.disabled) {
              console.log('Option is disabled:', value);
              return; // Don't allow selection of disabled options
            }
          }

          // Update display
          selectedSpan.textContent = text;

          // Update original select
          if (originalSelect) {
            originalSelect.value = value;
            originalSelect.dispatchEvent(new Event('change'));
          }

          // Update option styling
          options.querySelectorAll('.custom-select-option').forEach(opt => {
            opt.classList.remove('selected');
          });
          this.classList.add('selected');

          // Close dropdown
          options.style.display = 'none';
          header.classList.remove('active');
          arrow.classList.remove('active');
        });
      });
    });
  }

  initCustomSelects();
};

export const initCtaFormPopups = () => {
  document.querySelectorAll(".cta-form-popup:not([data-cta-initialized])").forEach((popup) => {
    popup.dataset.ctaInitialized = "1";
  });

  markCtaPopupForms();
};

const bootForms = () => {
  initForms();
  initFormSelects();
  initCtaFormPopups();
  initAjaxFormSubmission();
};

export { initAjaxFormSubmission };

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", bootForms, { once: true });
} else {
  bootForms();
}
